// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2122b6ce","852":"d39647c1"}[chunkId] + ".chunk.js";
};